import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { Warehouse } from 'src/app/models/inventory/warehouse';
import { HistoricalWO } from 'src/app/models/maintenance/historicalWO';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, HeaderFilters, HttpService, MenuBreadCrumb, params, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
    selector: 'app-outputs',
    templateUrl: './outputs.component.html',
    styleUrls: ['./outputs.component.scss'],
    standalone: false
})
export class OutputsComponent implements OnInit {

  //menu
  public menuBreadCrumb:Array<MenuBreadCrumb>= [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Almacén Salidas",
      current:true
    }
  ]

  //urls
  public urlTableOI: string = `${EndpointDictionary.InventoryOutputsHistory.INVENT_OUTPUT_HISTORY_TABLE}`;
  private urlUser: string = `${EndpointDictionary.User.USER_COMBO}`;
  private urlItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;
  private urlPostOI: string = `${EndpointDictionary.InventoryOutputsHistory.CRUD_INVENT_OUTPUT_DATA}`;
  private urlWarehouses: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public selected = new UntypedFormControl(0);
  public labels = []
  public detailsClickRow = new HistoricalWO
  public totalCostItems: number
  public warehouses: Warehouse[]

// tabla historicos salidas
  public reloadTablaOI = new EventEmitter<any>();
  public configurationOI: TableConfiguration = {
    add: true,
    selectable: false,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    hideTitle:true,
    exportXslx: true,
    view: true
  };
  public columnsOI: TableColumns<HistoryInventory>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'warehouse',
      label: 'Bodega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'destinationWarehouseName',
      label: 'Bodega destino',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Número de Items',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'orderNumber',
      label: '# Orden Trabajo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'transferConsecutive',
      label: '# Traslado',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    }
  ];

  headerFileXlsm:Array<params> = [
    {id:"consecutive", value:"Consecutivo"},
    {id:"date", value:"Fecha de Registro"},
    {id:"warehouse", value:"Bodega"},
    {id:"userName", value:"Responsable"},
    {id:"userId", value:"Cédula"},
    {id:"totalCost", value:"Costo Total"},
    {id:"itemsCount", value:"Número de Items"},
    {id:"orderNumber", value:"# Orden de Trabajo"},
    {id:"transferConsecutive", value:"# Traslado"},
    {id:"destinationWarehouseName", value:"Bodega destino"},
  ]

 //tabla detalle historico
public reloadTablaDetails = new EventEmitter<any>()
public dataDetails: Array<InputOrOutputInventory> = []
public configurationDetails: TableConfiguration = {
   exportXslx: true,
   hideTitle:true,
   primaryKey: 'id'
}
public columnsDetails: TableColumns<InputOrOutputInventory>[] = [
  {
    ID: 'code',
    label: 'Código Item',
    type: 'text',
    style: {
      textAlign: 'center',
      movil: 'no-movil'
    },
  },
  {
    ID: 'itemName',
    label: 'Item',
    type: 'text',
    style: {
      textAlign: 'center',

    },
  },
  {
    ID: 'amount',
    label: 'Cantidad',
    type: 'number',
    style: {
      textAlign: 'center'
    },
  },
  {
    ID: 'costItem',
    label: 'Costo Unitario',
    type: 'thousandSeparator',
    style: {
      textAlign: 'center',
      movil: 'no-movil'
    },
  },
  {
    ID: 'totalCostItems',
    label: 'Costo Total Items',
    type: 'thousandSeparator',
    style: {
      textAlign: 'center'
    },
  }
]

headerDetailsFileXlsm:Array<params> = [
  {id:"code", value:"Código Item"},
  {id:"itemName", value:"Nombre Item"},
  {id:"amount", value:"Cantidad"},
  {id:"unitMeasurement", value:"Unidad"},
  {id:"costItem", value:"Costo Unidad"},
  {id:"totalCostItems", value:"Costo Total"},
  {id:"description", value:"Descripción Item"},
  {id:null, value:""},
  {id:null, value:""},
  {id:null, value:""},
  {id:null, value:""},
  {id:null, value:""},
  {id:null, value:""},
]
//filtros superiores
  headerFilters: Array<HeaderFilters> = []

  constructor(
    private router: Router,
    private http: HttpService,
    private functionEter: FunctionsService,
    private utils : UtilsServiceService,
    private activatedRoute: ActivatedRoute
  ) {
   }

  async ngOnInit(){
    this.warehouses = await this.http.getDataBody(`${this.urlWarehouses}`, [{ id: 'active', value: 1 }])
    this.initFilters(this.warehouses);
  }


  initFilters(warehouse: Warehouse[]){
    var value = '';
    if (this.warehouses.length === 1) {
      value = this.warehouses[0].id.toString();
    }

    this.headerFilters = [
      {
        tN: 'bodegas',
        labelFilter: 'Bodegas',
        visibleField: 'name',
        primaryKey: 'id',
        type: 'select',
        value: value,
        active: true,
        data: warehouse,
      },
      {
      tN: "item_inventario",
      labelFilter:"Item",
      urlData: this.urlItems,
      visibleField:"itemName",
      primaryKey:"id",
      type:"select",
      value:""
    },
    {
      tN: "usuarios",
      labelFilter:"Encargado",
      urlData: this.urlUser,
      visibleField:"name",
      primaryKey:"userId",
      type:"select",
      value:""
    },
    {
      tN: "hsi",
      visibleField:"fecha",
      type:"date",
      value:""
    },
    {
      tN: "hsi",
      visibleField:"fecha",
      type:"dateRange",
      value:""
    }]
  }

  addOI($event: HistoryInventory) {
    let warehouseIdSelected = this.headerFilters[0].value;
    let queryParams = warehouseIdSelected ? { warehouseId: warehouseIdSelected } : {};
    this.router.navigate(['detalle'], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
    });
  }

  async viewDetail($event: HistoryInventory[]) {
      this.selected.setValue(1)
      let res = await this.http.getDataBody<Array<HistoryInventory>>(`${this.urlPostOI}/${$event[0].id}`)
      if(res){
        this.dataDetails = res[0].items
        this.detailsClickRow = {
          id: -1,
          workOrderId: $event[0].orderId
        }
        this.totalCostItems = res[0].totalCost
        this.labelsFunction(res[0])
       }

  }

  selectedValue($event){
    this.selected.setValue($event.index)
  }

  private labelsFunction(dataHO: HistoryInventory){
    this.labels = [
      {
        label: 'Consecutivo (#):',
        value: dataHO.consecutive,
        edit:false
      },
      {
        label: 'Responsable:',
        value: dataHO.userName,
        edit:false
      },
      {
        label: 'Fecha:',
        value: this.functionEter.dateDB(new Date (dataHO.date)),
        edit:false
      },
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(dataHO.totalCost)}`,
        edit:false
      },
      {
        label: 'Bodega:',
        value: dataHO.warehouse,
        edit:false
      }
    ];

    if (dataHO?.destinationWarehouseName) {
      this.labels.push({
        label: 'Bodega destino:',
        value: dataHO.destinationWarehouseName,
        edit:false
      });
    }
    if (dataHO?.comment != "") {
      this.labels.push({
        label: 'Comentario:',
        value: dataHO.comment,
        edit:false
      });
      this.headerDetailsFileXlsm[11] = {id:null, value:`Comentario: ${dataHO.comment}`}
    }
    if (dataHO.orderId) {
      this.labels.push({
        label: 'Orden:',
        value: dataHO.orderNumber,
        edit:false
      });
      this.headerDetailsFileXlsm[12] = {id:null, value:`Orden de Trabajo: ${dataHO.orderId}`}
    }
      this.headerDetailsFileXlsm[7] = {id:null, value:`Consecutivo (#): ${dataHO.consecutive}`},
      this.headerDetailsFileXlsm[8] = {id:null, value:`Respomsable: ${dataHO.userName}`},
      this.headerDetailsFileXlsm[9] = {id:null, value:`Fecha de creación: ${this.functionEter.dateDB(new Date (dataHO.date))}`},
      this.headerDetailsFileXlsm[10] = {id:null, value:`Costo Total: $  ${Intl.NumberFormat('es-CO').format(dataHO.totalCost)}`}
  }

}
